import sdl from '@jds/react-generated-sdl/JDSTooltipInternal';
import type { JDSTooltipInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSTooltipInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    position = 'right',
    ariaLabel = 'label',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { position, ariaLabel, ...rest },
    'JDSTooltipInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const TooltipInternal = withLogic(
  Component
) as React.FC<JDSTooltipInternalProps> & { slotName?: string };

TooltipInternal.displayName = 'TooltipInternal';
TooltipInternal.slotName = 'jds_tooltip_internal';

export { TooltipInternal, type JDSTooltipInternalProps };
